const getSafeLoginUrl = (pathname: string, search: string, hash: string): string => {
	if (pathname === '/login') return '/login'

	const parameters = new URLSearchParams(search)
	parameters.delete('callbackUrl')

	const cleanSearch = parameters.size > 0 ? `?${parameters.toString()}` : ''
	const returnTo = pathname + cleanSearch + hash

	return returnTo.startsWith('/login') ? '/login' : `/login?callbackUrl=${encodeURIComponent(returnTo)}`
}

export default getSafeLoginUrl
